import React from 'react';
import { useSelector } from 'react-redux';

import Checkbox from 'dpl/form/components/Checkbox';
import { FILTER_HEALTH_TIER_LEVELS } from 'dpl/constants/query_params';
import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import SmartLink from 'dpl/components/SmartLink';
import { HEALTH_TESTING_GUIDE_PATH } from 'dpl/shared/constants/urls';

import FilterDrawer from './FilterDrawer';
import { healthTiersResourceDefinition } from '../utils/queryDefinitions';

export default function BreederBreedHealthFilter() {
  const { searchQueryFilterValues, toggleFilter } = useSearchQueryFilter(
    FILTER_HEALTH_TIER_LEVELS
  );

  const { breedName } = useSelector(({ server }) => server);

  const {
    value: { data: healthTiers }
  } = useResourceQuery(healthTiersResourceDefinition(true));

  return (
    <FilterDrawer title="Health testing">
      {healthTiers.map(({ id, name, title }) => (
        <div key={id} className="mb4">
          <Checkbox
            key={id}
            id={`${FILTER_HEALTH_TIER_LEVELS}_${id}`}
            name={name}
            title={`${title} level testing`}
            value={id}
            checked={searchQueryFilterValues.includes(Number(id))}
            onChange={e => toggleFilter(Number(e.target.value))}
          />
        </div>
      ))}
      <div className="bg-lightest-purple w-100 ph4 pv2 br3 f2">
        <SmartLink
          className="purple underline"
          to={HEALTH_TESTING_GUIDE_PATH}
          target="_blank"
        >
          Learn more
        </SmartLink>{' '}
        about health testing for {breedName}.
      </div>
    </FilterDrawer>
  );
}
